import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';

export interface ErrorMessageProps {
    name;
    error;
}

@observer export class ErrorMessage extends Component<ErrorMessageProps, any> {

    render() {
        const { name, error } = this.props;

        return <div className="invalid-feedback">
            { Object.values(error.constraints).join('; ') }
        </div>
    }

}
